/* Navani · motion engine — reveal on scroll + magnetic + hero parallax.
   Sin dependencias. Scroll nativo (sin Lenis) para máximo rendimiento. */
(function () {
  'use strict';
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll (a prueba de balas: nunca deja contenido invisible) ---- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('.nv-reveal, .nv-reveal-line'));
    if (rm || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // Lo que ya está dentro o por encima del viewport al cargar: mostrar YA (sin esperar scroll).
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92) el.classList.add('is-in');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = el.getAttribute('data-delay');
        if (d) { el.style.transitionDelay = d + 'ms'; }
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
    // Red de seguridad: pase lo que pase, a los 2.2s nada queda invisible.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 2200);
  }

  /* ---- Magnetic ---- */
  function initMagnetic() {
    if (rm || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
      var str = parseFloat(el.getAttribute('data-magnetic')) || 0.3;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var mx = e.clientX - (r.left + r.width / 2);
        var my = e.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + mx * str + 'px,' + my * str + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---- Parallax (hero / showcase) [data-parallax="speed"] ---- */
  function initParallax() {
    if (rm) return;
    var nodes = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if (!nodes.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      nodes.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        var prog = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translateY(' + (prog * speed * 100).toFixed(2) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function init() { initReveal(); initMagnetic(); initParallax(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
